import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { updateTenant } from "../../../store/authSlice";
import clinicAPI from "../../../services/clinicApi";
import RegistrationLinksPanel from "../AdminSettings/RegistrationLinksPanel";
import { usePatientsBase } from "../../../utils/hubPaths";
import { useAdminHubUi } from "../../../hooks/useAdminAppMode";
import { HubScreen } from "../AdminPortal/HubPwa";
import aa from "../AdminPortal/adminApp.module.css";
import s from "../clinic.module.css";
import { Button, useToast } from "../../ui";

export default function AdminClientsRegistration() {
  const navigate = useNavigate();
  const patientsBase = usePatientsBase();
  const isApp = useAdminHubUi();
  const toast = useToast();
  const dispatch = useDispatch();
  const [autoApprove, setAutoApprove] = useState(true);
  const [savingApprove, setSavingApprove] = useState(false);
  const [defaultUrl, setDefaultUrl] = useState("");

  useEffect(() => {
    clinicAPI
      .getTenantSettings()
      .then((data) => {
        const t = data.tenant || data;
        setAutoApprove(t.auto_approve_registrations !== false);
      })
      .catch(() => {});
    clinicAPI
      .getDefaultRegistrationLink()
      .then((data) => setDefaultUrl(data.link?.url || ""))
      .catch(() => {});
  }, []);

  const saveAutoApprove = async (next) => {
    setAutoApprove(next);
    setSavingApprove(true);
    try {
      const data = await clinicAPI.updateTenantSettings({
        auto_approve_registrations: next,
      });
      const t = data.tenant || data;
      dispatch(updateTenant(t));
      toast.success("Сохранено");
    } catch (e) {
      setAutoApprove(!next);
      toast.error(e.response?.data?.error || "Ошибка");
    } finally {
      setSavingApprove(false);
    }
  };

  const copyDefault = async () => {
    if (!defaultUrl) return;
    try {
      await navigator.clipboard.writeText(defaultUrl);
      toast.success("Ссылка скопирована");
    } catch {
      toast.error("Не удалось скопировать");
    }
  };

  const body = (
    <div className={aa.clientsRegistrationPage}>
      <section className={aa.clientsRegistrationHero}>
        <div className={aa.clientsRegistrationHeroIcon} aria-hidden>
          🔗
        </div>
        <div className={aa.clientsRegistrationHeroText}>
          <h2 className={aa.clientsRegistrationHeroTitle}>Регистрация клиентов</h2>
          <p className={aa.clientsRegistrationHeroDesc}>
            Публичные ссылки для самостоятельной записи. Заявки попадают в фильтр
            «На модерации» — после подтверждения клиент получит приглашение задать
            пароль.
          </p>
        </div>
      </section>

      {defaultUrl ? (
        <div className={aa.clientsRegistrationQuick}>
          <div className={aa.clientsRegistrationQuickText}>
            <span className={aa.clientsRegistrationQuickLabel}>Общая ссылка клуба</span>
            <code className={aa.clientsRegistrationQuickUrl}>{defaultUrl}</code>
          </div>
          <Button type="button" size="sm" variant="secondary" onClick={copyDefault}>
            Копировать
          </Button>
        </div>
      ) : null}

      <div className={aa.clientsRegistrationToggle}>
        <label className={s.settingsToggleRow}>
          <input
            type="checkbox"
            checked={autoApprove}
            disabled={savingApprove}
            onChange={(e) => saveAutoApprove(e.target.checked)}
          />
          <span>
            <strong>Автоподтверждение заявок</strong>
            <span className={s.branchCheckAddr}>
              Если выключено — новые клиенты ждут одобрения в разделе «На модерации»
            </span>
          </span>
        </label>
      </div>

      <RegistrationLinksPanel compact={isApp} />
    </div>
  );

  if (isApp) {
    return (
      <HubScreen
        title="Регистрация"
        onBack={() => navigate(patientsBase)}
        backLabel="Клиенты"
      >
        {body}
      </HubScreen>
    );
  }

  return (
    <div className={aa.clientsHub}>
      <nav className={s.patientBreadcrumbs} aria-label="Навигация">
        <Link to={patientsBase}>Клиенты</Link>
        <span aria-hidden>/</span>
        <span>Регистрация</span>
      </nav>
      {body}
    </div>
  );
}
